"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteBlock = deleteBlock;
exports.getBlock = getBlock;
exports.getBlockCodeByBlockCodeDict = getBlockCodeByBlockCodeDict;
exports.getSysUserBlockByBlockCode = getSysUserBlockByBlockCode;
exports.resetAllUsersSysUserBlock = resetAllUsersSysUserBlock;
exports.resetSelectedSysUserBlock = resetSelectedSysUserBlock;
exports.restoreBlock = restoreBlock;
exports.saveBlock = saveBlock;
exports.updateBlock = updateBlock;
exports.updateFixFlagBlock = updateFixFlagBlock;
exports.updateSysUserBlock = updateSysUserBlock;
var _request = _interopRequireDefault(require("@/utils/request"));
/* 工作台配置模块 */
/* 1.加载功能区块 */
function getBlock(query) {
  return (0, _request.default)({
    url: '/sitceb-system-service/sysBlock/selectBlock/' + query.applyType,
    method: 'get'
  });
}
/* 2.隐藏功能区块 */
function deleteBlock(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/sysBlock/deleteBlock',
    method: 'post',
    data: data
  });
}
/* 3.编辑功能区块 */
function updateBlock(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/sysBlock/updateBlock',
    method: 'post',
    data: data
  });
}
/* 4.添加功能区块 */
function saveBlock(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/sysBlock/saveBlock',
    method: 'post',
    data: data
  });
}
/* 5.恢复默认 */
function restoreBlock(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/sysBlock/restoreSysUserBlock/singleShip',
    method: 'post',
    data: data
  });
}
/* 6.固定 暂不用*/
function updateFixFlagBlock(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/sysBlock/updateFixFlagBlock',
    method: 'post',
    data: data
  });
}
/* 7。根据区块找到对应的子类型数据字典进行获取 */
function getSysUserBlockByBlockCode(query) {
  return (0, _request.default)({
    url: '/sitceb-system-service/sysBlock/getSysUserBlockByBlockCode',
    method: 'get',
    params: query
  });
}
/* 8. 根据字典代码获取功能区块数据字典清单 */
function getBlockCodeByBlockCodeDict(query) {
  return (0, _request.default)({
    url: '/sitceb-system-service/sysBlock/getBlockCodeByBlockCodeDict',
    method: 'get',
    params: query
  });
}

/* 9. 移动 */
function updateSysUserBlock(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/sysBlock/updateSysUserBlock',
    method: 'post',
    data: data
  });
}

/* 10. 重置用户某个区块信息 */
function resetAllUsersSysUserBlock(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/sysBlock/resetAllUsersSysUserBlock',
    method: 'post',
    data: data
  });
}
function resetSelectedSysUserBlock(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/sysBlock/resetSysUserBlockByUserIds',
    method: 'post',
    data: data
  });
}